import React from "react";

export default function AI() {

    return (
        <div>
        <iframe 
        style={{ display: 'block', width: '100%', minHeight: 800, border: 'none'}}
        src="https://xpnademo.eaciitapp.com/dashboard/hotel-prices-analysis/"
        title="AI Agent for Hotel Prices Analysis">
        </iframe>
        </div>
    )
}